import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import {encode} from './ConfigCode';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const SaveLoadPopUp = ({ config, editorMode }) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [hashConfig, setHashConfig] = React.useState(encode(config));

  const handleClickOpen = () => {
    const url = window.location.href.split('?')[0];
    if (editorMode) {
      setHashConfig(url + '?code=' + encode(config) + '&editor_mode=' + editorMode)
    } else {
      setHashConfig(url + '?code=' + encode(config))
    }
    
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  const onChange = (event) => {
    setHashConfig(event.target.value);
  }

  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen} startIcon={<SaveIcon />} fullWidth>
       {t('drawer.save')}</Button>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
        <DialogContent>
          <TextField
            id="standard-multiline-flexible"
            label={t('dialog.saveCode')}
            multiline
            maxRows={10}
            onChange={onChange}
            value={hashConfig}
            variant="standard"
            style={{width:'280px'}}
          />
        </DialogContent>
        <Typography variant="caption" align="center" style={{color: '#BBBBBB'}}>{t('dialog.disclaimer')}</Typography>
        <DialogActions>
          <Button onClick={handleClose}>{t('drawer.close')}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SaveLoadPopUp;